import {createAction, props} from '@ngrx/store';
import {Notification} from '@automata/models/notification';

export const LoadNotifications = createAction('[Notifications] Load Start');
export const LoadNotificationsComplete = createAction('[Notifications] Load Complete', props<{notifications: Notification[]}>());
